import { MarisolPage } from "./Marisol.page.tsx";

export default MarisolPage;
